export const ADMIN = 'admin'
export const MANAGER = 'manager'
export const WORKER = 'worker'
